import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useBuyPlans } from './useHook';
import ModalAddBuyPlan from '../../Components/Modals/BuyPlans/BuyPlansModal';
import { MdDelete, MdEdit } from 'react-icons/md';
import { useNavigate } from "react-router-dom";
import { IoEye } from "react-icons/io5";

function BuyPlans() {
    const navigate = useNavigate();
    const { createPlan, deletePlan, getPlans, updatePlan } = useBuyPlans();
    const [plansData, setPlansData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editPlan, setEditPlan] = useState(null);

    const fetchPlans = async () => {
        await getPlans(setPlansData);
    };

    useEffect(() => {
        fetchPlans();
    }, []);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
        setIsModalOpen(false);
        setEditPlan(null);
    };
    const handlePageView = (buyPlanId) => {
        navigate("/buy-this-plan/details", { state: { buyPlanId } });
    }
    const handleAddOrUpdatePlan = async (planData, planId = null) => {
        try {
            if (planId) {
                const response = await updatePlan(planId, planData);
                if (response) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Plan Updated',
                        text: 'Plan has been updated successfully!',
                    });
                }
            } else {
                const response = await createPlan(planData);
                if (response) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Plan Added',
                        text: 'Plan has been added successfully!',
                    });
                }
            }
            await fetchPlans();
        } catch {
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: 'An error occurred. Please try again.',
            });
        }
        closeModal();
    };

    const handleEditPlan = (plan) => {
        setEditPlan(plan);
        openModal();
    };

    const handleDeletePlan = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        });

        if (result.isConfirmed) {
            try {
                const response = await deletePlan(id);
                if (response) {
                    Swal.fire('Deleted!', 'The plan has been deleted.', 'success');
                    await fetchPlans();
                }
            } catch {
                Swal.fire('Error!', 'Failed to delete the plan.', 'error');
            }
        }
    };

    return (
        <>
            <div>
                <div className="bg-gray-100 p-4 flex justify-between">
                    <h2 className="text-2xl font-bold">Manage Buy Plans</h2>
                    <button
                        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded"
                        onClick={openModal}
                    >
                        Add Plan
                    </button>
                </div>

                <div className="mt-4">
                    <div className="bg-gray-100">
                        <div className="overflow-x-auto mt-6">
                            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                                <thead>
                                    <tr className="bg-gradient-to-r from-primary-dark to-primary-light text-white">
                                        <th className="p-4 text-left">Sr. No</th>
                                        <th className="p-4 text-left">Name</th>
                                        <th className="p-4 text-left">Up To 5 Marla</th>
                                        <th className="p-4 text-left">From 5 to 8 Marla</th>
                                        <th className="p-4 text-left">From 8 to 12 Marla</th>
                                        <th className="p-4 text-left">From 12 to 18 Marla</th>
                                        <th className="p-4 text-left">From 18 to 25 Marla</th>
                                        <th className="p-4 text-left">Above 25 Marla</th>
                                        <th className="p-4 text-left">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plansData?.map((plan, index) => (
                                        <tr key={plan.id} className="border-t border-gray-200 hover:bg-gray-50">
                                            <td className="p-4">{index + 1}</td>
                                            <td className="p-4">{plan.name}</td>
                                            <td className="p-4">{plan.upto_5_marla}</td>
                                            <td className="p-4">{plan.from_5_to_12_marla}</td>
                                            <td className="p-4">{plan.from_8_to_12_marla}</td>
                                            <td className="p-4">{plan.from_12_to_18_marla}</td>
                                            <td className="p-4">{plan.from_18_to_25_marla}</td>
                                            <td className="p-4">{plan.above_25_marla}</td>
                                            <td className="px-4 py-2 border-b">
                                                <div className="flex gap-2">
                                                    <button
                                                        className="bg-primary-dark text-white py-2 px-4 rounded-lg shadow-md flex items-center"
                                                        onClick={() => handleEditPlan(plan)}
                                                    >
                                                        <MdEdit />
                                                    </button>
                                                    <button
                                                        onClick={() => handleDeletePlan(plan.id)}
                                                        className="bg-red-500 text-white py-2 px-4 rounded-lg shadow-md flex items-center"
                                                    >
                                                        <MdDelete />
                                                    </button>
                                                    <button
                                                        onClick={() => handlePageView(plan.id)}
                                                        className="bg-red-500 text-white py-2 px-4 rounded-lg shadow-md flex items-center"
                                                    >
                                                        <IoEye />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <ModalAddBuyPlan
                isOpen={isModalOpen}
                onClose={closeModal}
                onSubmit={handleAddOrUpdatePlan}
                editPlan={editPlan}
            />
        </>
    );
}

export default BuyPlans;
